import axios from '@/lib/axios';
import { UserInvitation, Workspace } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0300. チームメンバー登録
 * [POST] /workspaces/:identifier/teams/:team_id/team_members
 */
type Props = {
  identifier: string;
  team_id: number;
  user_id: number;
  'role_ids[]': string[];
  default_backofficer: boolean;
  default_approver: boolean;
};
const createTeamMember = (props: Props): Promise<UserInvitation> => {
  return axios.post(`/api/workspaces/${props.identifier}/teams/${props.team_id}/team_members`, props);
};

export const useCreateTeamMember = () => {
  return useMutation({
    mutationFn: createTeamMember,
  });
};
